import bgImage from '../../assets/moneybank.png' 

export default function Airdrop(){
    return(
        <section
        id='about'
        className="about-section pt-120 pb-120 bg_img"
        data-background={bgImage}
      >
        <div className="container">
          <div className="row">
         <div className='col-md-6'>
         <img style={{marginLeft:'20%', marginRight:'25%' , marginTop:'-50px', borderRadius:'20px'}} width={'70%'} src='https://life2.io/wp-content/uploads/2023/05/IMG_4649.80f370ad6567a151744c.gif' alt='..' />
            
            {/* <img style={{marginLeft:'20%', marginRight:'25%' , marginTop:'-50px', borderRadius:'20px'}} width={'70%'} src='https://public.bnbstatic.com/static/academy/uploads/8456ba0fa9e64f0992d5f7b549af3597.jpg' alt='..' /> */}
            {/* <iframe src="https://app.vectary.com/p/1e8UtgqYjeQ1Yhd02sQR6N" frameborder="0" width="100%" height="480"></iframe> */}
            </div>
         {/* offset-lg-6 */}
            <div className="col-md-6 ">
              <div className="about-content">
                <h2 className="section-title mb-3">
                <span style={{color:'white'}} className="base--color">NFT</span>{" "}
                  {/* <span className="font-weight-normal">NFT</span>{" "} */}
                  <b className="base--color">airdrops</b>
                </h2>
               
                <p className="mt-4">
                Any one who buys usd 250 worth of tokens will get a airdrop of one unique EGOE NFT check life2.io worth 100 usd as airdrop .

                </p>
                
              </div>
              {/* about-content end */}
            </div>
          </div>
        </div>
      </section>      
    );
}